<app-modal *ngIf="showModalNotificacao && (validPermissionToView(perfisQuePodemVerOModal)
                                            || exibirPlanoContingenciaPendente
                                            || exibirPlanoContingenciaPendenteDiretor
                                            || exibirPlanoMelhoriaPendente
                                            || exibirPlanoMelhoriaPendenteDiretor
                                            || exibirPlanoContingenciaParaAjustarDiretor
                                            || exibirPmceParaAjustarDiretor
                                            || exibirPlanoContingenciaParaValidarSupervisor
                                            || exibirPmceParaValidarSupervisor
                                            || mensagemNotificacao.length > 0
                                          )" class="modal-notificacao-alert">

  <div class="modal" [class.shake]="isShaking">
    <div class="modal-header">
      <h1>Aviso de pendências</h1>
    </div>
    <div class="modal-conteudo">
      <div *ngIf="exibirPlanoContingenciaPendente" class="alerta-plano row">
        <p class="col-8">
          <ng-container *ngIf="contagemPlanoContingenciaValidacao > 0; else txtPcPecUm">
            Você tem {{ contagemPlanoContingenciaValidacao }} Plano(s) de Contingência para validar
          </ng-container>
          <ng-template #txtPcPecUm>Você tem um Plano de Contingência para validar</ng-template>
        </p>
        <a class="link-plano col-4" [routerLink]="['/plano-contingencia/consulta']" [queryParams]="{ validacao: 'pec' }">Visualizar agora</a>
        <hr>
      </div>
      <div *ngIf="exibirPlanoContingenciaPendenteDiretor" class="alerta-plano row">
        <p class="col-8">
          Você tem um Plano de Contingência para preencher
        </p>
        <a class="link-plano col-4" routerLink="/plano-contingencia/cadastro">Preencher agora</a>
        <hr>
      </div>
      <div *ngIf="exibirPlanoContingenciaParaAjustarDiretor" class="alerta-plano row">
        <p class="col-8">
          Atenção! Você tem um Plano de Contingência para ajustar
        </p>
        <a class="link-plano col-4" routerLink="/plano-contingencia/consulta">Ajustar agora</a>
        <hr>
      </div>

      <hr>
      <div *ngIf="perfil === Perfil.PEC && (contagemPmceValidacao > 0 || (planosMelhoriaPendentes?.length ?? 0) > 0)" class="alerta-plano row">
        <p class="col-8">
          <ng-container *ngIf="contagemPmceValidacao > 0; else txtPmcePecUm">
            Você tem {{ contagemPmceValidacao }} Plano(s) da Melhoria de Convivência Escolar para validar
          </ng-container>
          <ng-template #txtPmcePecUm>Você tem um Plano da Melhoria de Convivência Escolar para validar</ng-template>
        </p>
        <a class="link-plano col-4" [routerLink]="['/plano-melhoria/consulta']" [queryParams]="{ validacao: 'pec' }">Visualizar agora</a>
        <hr>
      </div>
      <div *ngIf="exibirPlanoMelhoriaPendenteDiretor" class="alerta-plano row">
        <p class="col-8">
          Você tem um Plano da Melhoria de Convivência Escolar para preencher
        </p>
        <a class="link-plano col-4" routerLink="/plano-melhoria/cadastro">Preencher agora</a>
        <hr>
      </div>
      <div *ngIf="exibirPmceParaAjustarDiretor" class="alerta-plano row">
        <p class="col-8">
          Atenção! Você tem um PMCE para ajustar
        </p>
        <a class="link-plano col-4" routerLink="/plano-melhoria/consulta">Ajustar agora</a>
        <hr>
      </div>

      <div *ngIf="exibirPlanoContingenciaParaValidarSupervisor" class="alerta-plano row">
      <p class="col-8">
        <ng-container *ngIf="contagemPlanoContingenciaValidacao > 0; else txtPcSupUm">
          Você tem {{ contagemPlanoContingenciaValidacao }} Plano(s) de Contingência para validar
        </ng-container>
        <ng-template #txtPcSupUm>Você tem um Plano de Contingência para validar</ng-template>
      </p>
      <a class="link-plano col-4" [routerLink]="['/plano-contingencia/consulta']" [queryParams]="{ validacao: 'supervisor' }">Visualizar agora</a>
      <hr>
    </div>

    <div *ngIf="exibirPmceParaValidarSupervisor" class="alerta-plano row">
      <p class="col-8">
        <ng-container *ngIf="contagemPmceValidacao > 0; else txtPmceSupUm">
          Você tem {{ contagemPmceValidacao }} Plano(s) da Melhoria de Convivência Escolar para validar
        </ng-container>
        <ng-template #txtPmceSupUm>Você tem um Plano da Melhoria de Convivência Escolar para validar</ng-template>
      </p>
      <a class="link-plano col-4" [routerLink]="['/plano-melhoria/consulta']" [queryParams]="{ validacao: 'supervisor' }">Visualizar agora</a>
      <hr>
    </div>
      <hr>
      <div class="alerta-plano row">
        <p class="col-8">
          Você tem <b>{{GetTotalChamadosAtrasados()}}</b> ocorrências aguardando sua análise (SLA).
        </p>
        <a class="link-plano col-4" routerLink="/listar-chamados">
          Ir para chamados
        </a>
        <hr>
      </div>

      <!-- <ul>
        <li *ngIf="podeVisualizarCountChamadosPendentes"><b> {{countChamadoPorStatus('Pendente análise do chamado')}} </b> Pendente análise do chamado</li>
        <li *ngIf="podeVisualizarCountChamadosAtrasadoAgendamento"><b> {{countChamadoPorStatus('Atrasado Agendamento do Psicólogo')}} </b> Atrasado Agendamento do Psicólogo</li>
        <li *ngIf="podeVisualizarCountChamadosAtrasadoAtendimento"><b> {{countChamadoPorStatus('Aguardando Atendimento do Psicólogo')}} </b> Aguardando Atendimento do Psicólogo</li>
        <li *ngIf="podeVisualizarCountChamadosAguardandoEncerramento"><b> {{countChamadoPorStatus('Aguardando Encerramento')}} </b> Aguardando Encerramento</li>
      </ul>
      <a class="btn_outline" routerLink="/listar-chamados">
        Verificar
      </a> -->
    </div>
    <button class="btn-primary" (click)="closeModalNotificacao()">Fechar</button>
  </div>
</app-modal>

<!-- <button (click)="openModalNotificacao()">Abrir Modal</button> -->
